import { useMemo } from 'react';

import { capitalizeFirstCharLowerOthers } from '@utils/formatting-utils';

import { useGetMedicalInsuredsLovs } from '../proposal.slice';
import { MedicalInsuredsLovs } from '../types';

export function useMedicalInsuredsLovs(
  isMedicalOrTravel: boolean
): MedicalInsuredsLovs {
  const { data } = useGetMedicalInsuredsLovs({ skip: !isMedicalOrTravel });

  return useMemo(() => {
    const continuityRaw = data?.ContinuityList?.enumValues ?? [];
    const relationRaw = data?.RelationsList?.enumValues ?? [];

    const continuity: Record<string, string> = continuityRaw
      .map((g) => g?.name)
      .filter((s): s is string => Boolean(s))
      .reduce(
        (acc, curr) => {
          acc[curr] = capitalizeFirstCharLowerOthers(curr);

          return acc;
        },
        {} as Record<string, string>
      );

    const relation: Record<string, string> = relationRaw
      .map((g) => g?.name)
      .filter((s): s is string => Boolean(s))
      .reduce(
        (acc, curr) => {
          acc[curr] = capitalizeFirstCharLowerOthers(curr);

          return acc;
        },
        {} as Record<string, string>
      );

    return { relation, continuity, grApplicable: { YES: 'Yes', NO: 'No' } };
  }, [data]);
}
